import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { Person } from '../pages/person'
import { PersonAddress } from '../pages/person-address'
import { PersonContact } from '../pages/person-contact'

export default function Component() {
  return (
    <Routes>
      <Route index element={<Person.List />} />
      <Route path="novo" element={<Person.Create />} />
      <Route path=":person_id" element={<Outlet />}>
        <Route index element={<Person.Dashboard />} />
        <Route path="editar" element={<Person.Edit />} />
        <Route path="enderecos/novo" element={<PersonAddress.Create />} />
        <Route path="enderecos/:address_id" element={<PersonAddress.Edit />} />
        <Route path="contatos/novo" element={<PersonContact.Create />} />
        <Route path="contatos/:contact_id" element={<PersonContact.Edit />} />
        <Route path="*" element={<Navigate to="" />} />
      </Route>
    </Routes>
  )
}
